/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import { useEffect, useState } from 'react'

import { MEDIA_MAX_WIDTH } from '../app/Theme'
import { useWindowSize } from './useWindowSize'

type ScreenState = Record<'isMobile' | 'isDesktop', boolean>

const INITIAL_SCREEN_STATE: ScreenState = {
  isMobile: false,
  isDesktop: false
}

export const useMediaScreenType = () => {
  const [screenState, setScreenState] = useState<ScreenState>(INITIAL_SCREEN_STATE)

  const windowSize = useWindowSize()

  useEffect(() => {
    const { width } = windowSize
    let subscribed = true

    if (!width || !subscribed) return

    setScreenState({
      isMobile: width <= MEDIA_MAX_WIDTH.mobile,
      isDesktop: width >= MEDIA_MAX_WIDTH.mobile + 1 && width <= MEDIA_MAX_WIDTH.desktop
    })

    return () => {
      subscribed = false
    }
  }, [windowSize])

  return screenState
}
